import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StripeContextService } from '../../@core/backend/receptionist/services/stripe-context.service';

@Component({
  selector: 'r247-card-details',
  templateUrl: './card-details.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class R247CardDetailsComponent implements AfterViewInit, OnChanges {
  constructor(private stripeContextService: StripeContextService) { }

  get cardholderName() { return this.cardDetailsForm.get('name'); }
  get cardDescription() { return this.cardDetailsForm.get('cardDescription'); }
  get saveCardDetails() { return this.cardDetailsForm.get('saveCardDetails'); }

  @Input() forceSaveCardDetails = false;
  @Input() hideSaveCardDetails = false;
  @Input() cardholderNameDefault = '';
  @Input() stripeKey = '';
  @Input() cardDetailsForm: FormGroup;

  @Output() cardDetailsFormChanged = new EventEmitter<FormGroup>();

  private viewReady = false;
  private stripeMounted = false;

  stripeInitError = '';

  ngAfterViewInit() {
    this.viewReady = true;
    this.tryInitStripe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.stripeKey)
      this.tryInitStripe();
  }

  private tryInitStripe() {
    if (!this.viewReady || this.stripeMounted)
      return;

    if (!this.stripeKey) {
      this.stripeInitError = 'Stripe key not configured.';
      return;
    }

    const error = this.stripeContextService.mount(this.stripeKey);

    this.stripeMounted = !error;
    this.stripeInitError = error;
  }

  get stripeState() {
    return this.stripeContextService.stripeState;
  }

  markAllAsTouched() {
    this.stripeContextService.markAllAsTouched();
  }

  get invalid() {
    return !this.stripeContextService.isCardValid();
  }

}
